import alertImg from "./../Assets/images/alertBtn.png";
import crossImg from "./../Assets/images/crossBtn.png";
import checkImg from "./../Assets/images/okBtn.png";
import dispatchImg from "./../Assets/images/dispatchOk.png";

export const messages = [
  {
    id: 1,
    msg: "Something wrong Room is not responding!",
    status: 0,
    color: "#882B2B",
    background: "#F2C1C1",
    img: crossImg,
    prepared: 0,
  },
  {
    id: 2,
    msg: "New Order from Room",
    status: 1,
    color: "#376521",
    background: "#E1FCD4",
    img: alertImg,
    prepared: 0,
  },
  {
    id: 3,
    msg: "Room just chcked-in",
    status: 5,
    color: "#376521",
    background: "#E1FCD4",
    img: alertImg,
    prepared: 0,
  },
  {
    id: 4,
    msg: "Item from Room Acknowledged Successfully",
    status: 2,
    color: "#2B5675",
    background: "#B4D1E6",
    img: checkImg,
    prepared: 0,
  },
  {
    id: 5,
    msg: "Order from Room Prepared Successfully",
    status: 2,
    color: "#205C38",
    background: "#B7E8CB",
    img: dispatchImg,
    prepared: 1,
  },
  {
    id: 6,
    msg: "Order from Room Dispatched Successfully",
    status: 3,
    color: "#205C38",
    background: "#B7E8CB",
    img: dispatchImg,
    prepared: 0,
  },
  {
    id: 7,
    msg: "Order from Room Delivered Successfully",
    status: 4,
    color: "#205C38",
    background: "#B7E8CB",
    img: dispatchImg,
    prepared: 0,
  },
];

export const PopMsg = [
  {
    id: 1,
    msg: "Are you sure, You want to acknowledge order?",
    status: 2,
  },

  {
    id: 2,
    msg: "Are you sure, You want to Dispatch order?",
    status: 3,
  },
  {
    id: 3,
    msg: "Are you sure, You want to Delivered order?",
    status: 4,
  },
];
